export default __webpack_public_path__ + "assets/images/d0422715d25f010b99d6ee54bb6896a2.png";